export function escapeHtml(value){
  return String(value??'')
    .replaceAll('&','&amp;')
    .replaceAll('<','&lt;')
    .replaceAll('>','&gt;')
    .replaceAll('"','&quot;')
    .replaceAll("'",'&#39;');
}

function safeDataAttributes(attributes={}){
  return Object.entries(attributes||{})
    .filter(([name,value])=>/^data-[a-z0-9_-]+$/i.test(String(name))&&value!=null)
    .map(([name,value])=>` ${escapeHtml(name)}="${escapeHtml(value)}"`)
    .join('');
}

export function button({id,label,variant='primary',type='button',disabled=false,loading=false,className='',attributes={}}={}){
  const safeVariant=['primary','secondary','danger','ghost'].includes(variant)?variant:'secondary';
  const text=loading?`Ładowanie…`:String(label||'');
  return `<button${id?` id="${escapeHtml(id)}"`:''} class="button button-${safeVariant}${className?` ${escapeHtml(className)}`:''}" type="${escapeHtml(type)}"${safeDataAttributes(attributes)}${disabled||loading?' disabled aria-disabled="true"':''}${loading?' aria-busy="true"':''}>${escapeHtml(text)}</button>`;
}

export function textField({id,name,label,type='text',placeholder='',autocomplete='',required=false,inputmode=''}={}){
  const fieldId=id||name;
  if(!fieldId)throw new TypeError('Field id or name is required');
  return `<label class="field" for="${escapeHtml(fieldId)}"><span class="field-label">${escapeHtml(label||'')}</span><input id="${escapeHtml(fieldId)}" name="${escapeHtml(name||fieldId)}" type="${escapeHtml(type)}"${placeholder?` placeholder="${escapeHtml(placeholder)}"`:''}${autocomplete?` autocomplete="${escapeHtml(autocomplete)}"`:''}${inputmode?` inputmode="${escapeHtml(inputmode)}"`:''}${required?' required':''}></label>`;
}

export function panel({title='',subtitle='',body='',className='',label=''}={}){
  const heading=title||subtitle
    ?`<div class="panel-heading">${title?`<strong>${escapeHtml(title)}</strong>`:''}${subtitle?`<span>${escapeHtml(subtitle)}</span>`:''}</div>`
    :'';
  return `<section class="panel${className?` ${escapeHtml(className)}`:''}"${label?` aria-label="${escapeHtml(label)}"`:''}>${heading}${body}</section>`;
}

export function message({text='',kind='neutral',role='status'}={}){
  const safeKind=['neutral','success','error','warning'].includes(kind)?kind:'neutral';
  return text?`<div class="message message-${safeKind}" role="${escapeHtml(role)}">${escapeHtml(text)}</div>`:'';
}

export function statusPill(parts=[]){
  const content=(parts||[]).filter(Boolean).map(escapeHtml).join(' · ');
  return `<div class="status-pill">${content}</div>`;
}

export function dangerZone({title,text,actionId,actionLabel}={}){
  return `<div class="danger-zone"><div><strong>${escapeHtml(title||'')}</strong><p>${escapeHtml(text||'')}</p></div>${button({id:actionId,label:actionLabel,variant:'danger'})}</div>`;
}
